class BackToTop {
  bar: HTMLDivElement | null;
  threshold = 100;

  constructor() {
    this.bar = document.querySelector<HTMLDivElement>('.kf-a-back-to-top');
  }

  init() {
    this.checkBarVisible();
    this.addEventToBar();

    window.addEventListener('scroll', () => {
      this.checkBarVisible();
    });
  }

  checkBarVisible() {
    if (window.scrollY > this.threshold) {
      this.bar?.classList.add('visible');
    } else if (window.scrollY === 0) {
      this.bar?.classList.remove('visible');
    }
  }

  addEventToBar() {
    this.bar?.addEventListener('click', this.onBarClick);
  }

  onBarClick() {
    window.scrollTo({ top: 0 });
  }
}

new BackToTop().init();

export {};
